/* ==========================================================================
   Кастомний чекаут UKR-TEC: ПІБ + телефон + Нова Пошта (область → місто →
   відділення) + оплата.

   Уся робота із секретами — на бекенді (Cloudflare Worker), адреса якого
   задається в налаштуваннях секції. Браузер надсилає лише variant_id та
   кількість; ціни й підсумок рахує Shopify на боці бекенду.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('np-checkout');
  if (!root) return;

  var API = (root.dataset.api || '').replace(/\/+$/, '');
  var CART_URL = root.dataset.cartUrl || '/cart';
  var CATALOG_URL = root.dataset.catalogUrl || '/collections/all';

  var form = document.getElementById('np-checkout-form');
  var done = root.querySelector('[data-done]');
  var submitButton = form.querySelector('[data-submit]');
  var submitLabel = form.querySelector('[data-submit-label]');
  var formError = form.querySelector('[data-form-error]');
  var areaSelect = form.querySelector('[data-area]');

  var liqpayOption = form.querySelector('[data-liqpay-option]');
  var liqpayInput = liqpayOption ? liqpayOption.querySelector('input') : null;
  var bankOption = form.querySelector('[data-bank-option]');
  var bankInput = bankOption ? bankOption.querySelector('input') : null;
  /* Накладений платіж вимикається чекбоксом у налаштуваннях секції —
     тоді цих елементів на сторінці немає взагалі. */
  var codOption = form.querySelector('[data-cod-option]');
  var codInput = codOption ? codOption.querySelector('input') : null;
  var paymentLoading = form.querySelector('[data-payment-loading]');
  var paymentNotice = form.querySelector('[data-payment-notice]');
  var doneNotice = done.querySelector('[data-done-notice]');
  var bankBlock = done.querySelector('[data-done-bank]');
  var retryButton = done.querySelector('[data-retry]');

  var config = {
    shippingPrice: Number(root.dataset.shippingPrice || 0),
    freeShippingFrom: Number(root.dataset.freeShippingFrom || 0)
  };

  var state = {
    cart: null,
    area: null, // { ref, name }
    city: null, // { ref, name }
    warehouse: null, // { ref, name }
    busy: false,
    paymentTouched: false, // покупець сам клацнув спосіб оплати
    liqpayAvailable: false,
    paymentSettled: false, // вже з'ясували, картка чи реквізити
    retry: null // { lp, orderName } для «Спробувати оплатити карткою ще раз»
  };

  /* ── Дрібні помічники ─────────────────────────────────────────────── */

  function api(path) {
    return API + path;
  }

  function debounce(fn, wait) {
    var timer = null;
    return function () {
      var args = arguments;
      var self = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(self, args);
      }, wait);
    };
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('uk-UA', {
        style: 'currency',
        currency:
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'UAH',
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ₴';
    }
  }

  function setText(selector, text) {
    var node = form.querySelector(selector);
    if (node) node.textContent = text;
  }

  function fieldWrap(input) {
    return input.closest('.np-field') || input.closest('.np-combo') || input.parentNode;
  }

  function showError(name, message) {
    var node = form.querySelector('[data-error="' + name + '"]');
    if (!node) return;
    node.textContent = message || '';
    node.classList.toggle('is-visible', Boolean(message));
    var input = form.querySelector('[name="' + name + '"]');
    if (input) fieldWrap(input).classList.toggle('has-error', Boolean(message));
  }

  function clearErrors() {
    form.querySelectorAll('.np-field__error').forEach(function (node) {
      node.textContent = '';
      node.classList.remove('is-visible');
    });
    form.querySelectorAll('.has-error').forEach(function (node) {
      node.classList.remove('has-error');
    });
    formError.hidden = true;
    formError.textContent = '';
  }

  function showFormError(message) {
    formError.textContent = message;
    formError.hidden = false;
  }

  /* ── Кошик і підсумок ─────────────────────────────────────────────── */

  function shippingCents() {
    if (!state.cart) return 0;
    if (config.freeShippingFrom > 0 && state.cart.total_price >= config.freeShippingFrom * 100) {
      return 0;
    }
    return config.shippingPrice * 100;
  }

  function renderSummary() {
    var list = form.querySelector('[data-summary-items]');
    var cart = state.cart;

    if (!cart || !cart.items.length) {
      list.innerHTML =
        '<li class="np-summary__empty">Кошик порожній. <a href="' +
        CATALOG_URL +
        '">До каталогу</a></li>';
      setText('[data-subtotal]', '—');
      setText('[data-shipping]', '—');
      setText('[data-total]', '—');
      submitButton.disabled = true;
      return;
    }

    list.innerHTML = cart.items
      .map(function (item) {
        var image = item.image
          ? '<img src="' +
            item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') +
            '" alt="" loading="lazy" width="60" height="60">'
          : '<span class="np-summary__placeholder" aria-hidden="true"></span>';

        var variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="np-summary__variant">' + item.variant_title + '</span>'
            : '';

        return (
          '<li class="np-summary__item">' +
          image +
          '<span><span class="np-summary__name">' +
          item.product_title +
          '</span>' +
          variant +
          '<span class="np-summary__qty">× ' +
          item.quantity +
          '</span></span>' +
          '<span class="np-summary__price">' +
          money(item.final_line_price) +
          '</span></li>'
        );
      })
      .join('');

    var shipping = shippingCents();
    setText('[data-subtotal]', money(cart.total_price));
    setText('[data-shipping]', shipping === 0 ? 'За тарифами перевізника' : money(shipping));
    setText('[data-total]', money(cart.total_price + shipping));
    submitButton.disabled = false;
  }

  function loadCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        state.cart = cart;
        renderSummary();
        return cart;
      })
      .catch(function () {
        showFormError('Не вдалося завантажити кошик. Оновіть сторінку.');
      });
  }

  /* Накладений платіж (якщо ввімкнений) видно одразу й завжди — він ні від
     чого не залежить. Картку показуємо, лише коли з'ясуємо, що LiqPay живий;
     якщо ні — замість неї відкриваємо реквізити. Вирішуємо один раз при
     завантаженні; далі картку можна лише вимкнути (перевірка перед
     сабмітом), але не ввімкнути назад. */
  function noLiqpayNotice() {
    return codOption
      ? 'Онлайн-оплата карткою зараз недоступна — оберіть накладений платіж або переказ за реквізитами.'
      : 'Онлайн-оплата карткою зараз недоступна — замовлення можна оплатити переказом за реквізитами.';
  }

  /* Що писати покупцеві, коли LiqPay відпав уже після заповнення форми
     і кнопку треба натиснути ще раз. */
  function retryHint() {
    return codOption
      ? 'Перевірте обраний спосіб оплати й натисніть кнопку ще раз.'
      : 'Натисніть «Підтвердити замовлення» ще раз, щоб оформити з оплатою за реквізитами.';
  }

  function settlePayment(liqpayOk) {
    if (state.paymentSettled) return;
    state.paymentSettled = true;
    if (paymentLoading) paymentLoading.hidden = true;
    if (liqpayOk) enableLiqpay();
    else disableLiqpay(noLiqpayNotice());
  }

  var paymentReady = null;

  function loadConfig() {
    var request = loadConfigInner().then(function (liqpayOk) {
      settlePayment(Boolean(liqpayOk));
    });
    // Бекенд або LiqPay довго мовчать — не тримаємо покупця, даємо реквізити.
    paymentReady = Promise.race([
      request,
      new Promise(function (resolve) {
        setTimeout(resolve, 9000);
      })
    ]).then(function () {
      settlePayment(false);
    });
    return paymentReady;
  }

  function loadConfigInner() {
    if (!API) return Promise.resolve(false);
    return fetch(api('/api/config'))
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (!data) return false;
        config.shippingPrice = Number(data.shippingPrice || 0);
        config.freeShippingFrom = Number(data.freeShippingFrom || 0);
        renderSummary();

        /* Картку показуємо, лише коли LiqPay налаштований на бекенді
           і liqpay.ua відповідає. Інакше — тільки реквізити. */
        if (!data.liqpayEnabled) return false;
        return probeLiqpay(5000);
      })
      .catch(function () {
        /* доставка — зі значень секції, оплата — реквізити */
        return false;
      });
  }

  /* ── Телефон ──────────────────────────────────────────────────────── */

  var phoneInput = form.querySelector('[name="phone"]');

  function formatPhone(value) {
    var digits = value.replace(/\D/g, '');
    if (digits.indexOf('380') === 0) digits = digits.slice(3);
    else if (digits.indexOf('80') === 0) digits = digits.slice(2);
    else if (digits.indexOf('0') === 0) digits = digits.slice(1);
    digits = digits.slice(0, 9);

    var out = '+380';
    if (digits.length) out += ' ' + digits.slice(0, 2);
    if (digits.length > 2) out += ' ' + digits.slice(2, 5);
    if (digits.length > 5) out += ' ' + digits.slice(5, 7);
    if (digits.length > 7) out += ' ' + digits.slice(7, 9);
    return out;
  }

  phoneInput.addEventListener('focus', function () {
    if (!phoneInput.value.trim()) phoneInput.value = '+380 ';
  });

  phoneInput.addEventListener('input', function () {
    phoneInput.value = formatPhone(phoneInput.value);
  });

  phoneInput.addEventListener('blur', function () {
    if (phoneInput.value.replace(/\D/g, '') === '380') phoneInput.value = '';
  });

  /* ── Автокомпліт (спільна логіка для міста й відділення) ──────────── */

  function Combo(name, options) {
    var wrap = form.querySelector('[data-combo="' + name + '"]');
    var input = wrap.querySelector('input');
    var list = wrap.querySelector('.np-combo__list');
    var clearButton = wrap.querySelector('[data-clear]');
    var items = [];
    var active = -1;
    var openRequest = 0;

    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }

    function open() {
      if (!items.length) return;
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function render(rows, emptyText) {
      items = rows;
      active = -1;

      if (!rows.length) {
        list.innerHTML =
          '<li class="np-combo__empty" role="presentation">' +
          (emptyText || 'Нічого не знайдено') +
          '</li>';
        open();
        return;
      }

      list.innerHTML = rows
        .map(function (row, index) {
          return (
            '<li role="option" data-index="' +
            index +
            '"><span class="np-combo__main">' +
            row.label +
            '</span>' +
            (row.hint ? '<span class="np-combo__hint">' + row.hint + '</span>' : '') +
            '</li>'
          );
        })
        .join('');
      open();
    }

    function highlight(index) {
      var nodes = list.querySelectorAll('li[role="option"]');
      if (!nodes.length) return;
      active = Math.max(0, Math.min(nodes.length - 1, index));
      nodes.forEach(function (node, i) {
        node.classList.toggle('is-active', i === active);
      });
      nodes[active].scrollIntoView({ block: 'nearest' });
    }

    function choose(index) {
      var row = items[index];
      if (!row) return;
      input.value = row.label;
      close();
      clearButton.hidden = false;
      options.onSelect(row.value);
    }

    var search = debounce(function () {
      var query = input.value.trim();
      var ticket = ++openRequest;

      list.innerHTML = '<li class="np-combo__empty" role="presentation">Шукаємо…</li>';
      open();

      options
        .fetch(query)
        .then(function (rows) {
          if (ticket !== openRequest) return;
          render(rows, options.emptyText);
        })
        .catch(function () {
          if (ticket !== openRequest) return;
          render([], 'Не вдалося завантажити. Спробуйте ще раз.');
        });
    }, 220);

    input.addEventListener('input', function () {
      clearButton.hidden = !input.value;
      options.onSelect(null);
      search();
    });

    input.addEventListener('focus', function () {
      if (!input.disabled) search();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (list.hidden) search();
        else highlight(active + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        highlight(active - 1);
      } else if (event.key === 'Enter') {
        if (!list.hidden && active >= 0) {
          event.preventDefault();
          choose(active);
        }
      } else if (event.key === 'Escape') {
        close();
      }
    });

    list.addEventListener('mousedown', function (event) {
      var li = event.target.closest('li[role="option"]');
      if (!li) return;
      event.preventDefault();
      choose(Number(li.dataset.index));
    });

    clearButton.addEventListener('click', function () {
      input.value = '';
      clearButton.hidden = true;
      options.onSelect(null);
      input.focus();
    });

    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) close();
    });

    return {
      input: input,
      reset: function (placeholder, disabled) {
        input.value = '';
        input.disabled = Boolean(disabled);
        if (placeholder) input.placeholder = placeholder;
        clearButton.hidden = true;
        close();
        options.onSelect(null);
      },
      enable: function (placeholder) {
        input.disabled = false;
        if (placeholder) input.placeholder = placeholder;
      }
    };
  }

  /* ── Каскад: область → місто → відділення ─────────────────────────── */

  function fetchJson(url) {
    return fetch(url).then(function (response) {
      if (!response.ok) throw new Error('http ' + response.status);
      return response.json();
    });
  }

  var cityCombo = Combo('city', {
    emptyText: 'Такого населеного пункту немає в списку Нової Пошти',
    fetch: function (query) {
      if (!state.area) return Promise.resolve([]);
      return fetchJson(
        api('/api/settlements?area=' + encodeURIComponent(state.area.ref) + '&q=' + encodeURIComponent(query))
      ).then(function (data) {
        return (data.items || []).map(function (row) {
          return {
            label: row.name,
            hint: [row.type, row.region].filter(Boolean).join(', '),
            value: { ref: row.ref, name: row.name }
          };
        });
      });
    },
    onSelect: function (value) {
      state.city = value;
      showError('city', '');
      if (value) {
        warehouseCombo.reset(warehousePlaceholder(), false);
        warehouseCombo.enable(warehousePlaceholder());
      } else {
        warehouseCombo.reset('Спочатку оберіть населений пункт', true);
      }
    }
  });

  function warehousePlaceholder() {
    return 'Номер, вулиця або «поштомат»';
  }

  var warehouseCombo = Combo('warehouse', {
    emptyText: 'У цьому населеному пункті нічого не знайдено',
    fetch: function (query) {
      if (!state.city) return Promise.resolve([]);
      return fetchJson(
        api(
          '/api/warehouses?settlement=' +
            encodeURIComponent(state.city.ref) +
            '&q=' +
            encodeURIComponent(query)
        )
      ).then(function (data) {
        return (data.items || []).map(function (row) {
          return {
            label: row.name,
            hint: row.short,
            value: { ref: row.ref, name: row.name, category: row.category }
          };
        });
      });
    },
    onSelect: function (value) {
      state.warehouse = value;
      showError('warehouse', '');
    }
  });

  function loadAreas() {
    if (!API) {
      areaSelect.innerHTML = '<option value="">Бекенд не налаштований</option>';
      return;
    }

    fetchJson(api('/api/areas'))
      .then(function (data) {
        var options = ['<option value="">Оберіть область</option>'];
        (data.items || []).forEach(function (row) {
          options.push('<option value="' + row.ref + '">' + row.name + '</option>');
        });
        areaSelect.innerHTML = options.join('');
      })
      .catch(function () {
        areaSelect.innerHTML = '<option value="">Не вдалося завантажити</option>';
        showFormError('Не вдалося отримати довідник Нової Пошти. Оновіть сторінку.');
      });
  }

  areaSelect.addEventListener('change', function () {
    var option = areaSelect.options[areaSelect.selectedIndex];
    state.area = areaSelect.value ? { ref: areaSelect.value, name: option.textContent.trim() } : null;
    showError('area', '');

    if (state.area) {
      cityCombo.reset('Почніть вводити назву', false);
      cityCombo.enable('Почніть вводити назву');
    } else {
      cityCombo.reset('Спочатку оберіть область', true);
    }
    warehouseCombo.reset('Спочатку оберіть населений пункт', true);
  });

  /* ── Валідація ────────────────────────────────────────────────────── */

  function validate() {
    clearErrors();
    var ok = true;

    function require(name, message, minLength) {
      var input = form.querySelector('[name="' + name + '"]');
      var value = input.value.trim();
      if (value.length < (minLength || 2)) {
        showError(name, message);
        ok = false;
        return null;
      }
      return value;
    }

    require('lastName', 'Вкажіть прізвище');
    require('firstName', "Вкажіть ім'я");
    require('middleName', 'Вкажіть по батькові');

    var digits = phoneInput.value.replace(/\D/g, '');
    if (digits.length !== 12) {
      showError('phone', 'Введіть номер у форматі +380 XX XXX XX XX');
      ok = false;
    }

    var email = form.querySelector('[name="email"]').value.trim();
    if (!email) {
      showError('email', 'Вкажіть email');
      ok = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showError('email', 'Перевірте адресу');
      ok = false;
    }

    if (!state.area) {
      showError('area', 'Оберіть область');
      ok = false;
    }
    if (!state.city) {
      showError('city', 'Оберіть населений пункт зі списку');
      ok = false;
    }
    if (!state.warehouse) {
      showError('warehouse', 'Оберіть відділення або поштомат зі списку');
      ok = false;
    }

    if (!state.cart || !state.cart.items.length) {
      showFormError('Кошик порожній.');
      ok = false;
    }

    if (!ok) {
      var firstError = form.querySelector('.has-error');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var input = firstError.querySelector('input, select');
        if (input && !input.disabled) input.focus({ preventScroll: true });
      }
    }

    return ok;
  }

  function selectedPayment() {
    var checked = form.querySelector('[name="payment"]:checked');
    return checked ? checked.value : 'bank';
  }

  function idleLabel() {
    return selectedPayment() === 'liqpay' ? 'Перейти до оплати' : 'Підтвердити замовлення';
  }

  function setBusy(busy, label) {
    state.busy = busy;
    submitButton.disabled = busy;
    submitButton.classList.toggle('is-busy', busy);
    submitLabel.textContent = busy ? label || 'Оформлюємо…' : idleLabel();
  }

  /* ── Екран після оформлення ───────────────────────────────────────── */

  var BANK_TEXT_WITH_DETAILS =
    'Оплатіть замовлення за реквізитами нижче. Після зарахування коштів відправимо посилку.';
  var BANK_TEXT_NO_DETAILS =
    'Реквізити для оплати надішлемо повідомленням. Після зарахування коштів відправимо замовлення.';

  var COD_TEXT =
    'Ми зв’яжемось для підтвердження й відправимо посилку накладеним платежем. ' +
    'Оплатите при отриманні у відділенні Нової Пошти — там же сплачується комісія перевізника.';

  function bankText() {
    return bankBlock ? BANK_TEXT_WITH_DETAILS : BANK_TEXT_NO_DETAILS;
  }

  /* opts: { title, orderName, notice, text, bank } */
  function renderDone(opts) {
    form.hidden = true;
    done.hidden = false;
    done.querySelector('[data-done-title]').textContent = opts.title || 'Замовлення прийнято';
    done.querySelector('[data-done-number]').textContent = opts.orderName || '—';
    done.querySelector('[data-done-text]').textContent = opts.text || '';

    doneNotice.textContent = opts.notice || '';
    doneNotice.hidden = !opts.notice;

    if (bankBlock) {
      bankBlock.hidden = !opts.bank;
      var inline = bankBlock.querySelector('[data-done-number-inline]');
      if (inline) inline.textContent = opts.orderName || '';
    }

    state.retry = opts.retryId ? { lp: opts.retryId, orderName: opts.orderName } : null;
    if (retryButton) {
      retryButton.hidden = !opts.retryId;
      retryButton.disabled = false;
      retryButton.textContent = 'Спробувати оплатити карткою ще раз';
    }

    window.scrollTo({ top: root.offsetTop - 40, behavior: 'smooth' });
  }

  function showDone(orderName, options) {
    options = options || {};
    /* Накладеному платежу реквізити не потрібні — гроші беруть на відділенні. */
    var isCod = options.payment === 'cod';
    renderDone({
      title: 'Замовлення прийнято',
      orderName: orderName,
      notice: options.notice || '',
      text: isCod ? COD_TEXT : bankText(),
      bank: !isCod,
      retryId: options.retryId || ''
    });
  }

  /* ── LiqPay ───────────────────────────────────────────────────────────

     Картка приймається лише на сторінці liqpay.ua. Страховка на кожному
     кроці. Поки замовлення ще НЕ створене, запасним стає накладений платіж
     (а реквізити просто показуються поруч); якщо замовлення вже створене,
     запасний шлях один — переказ за реквізитами, бо посилку з післяплатою
     заднім числом не переоформиш:

       1. бекенд каже liqpayEnabled: false        → опції «Картка» немає;
       2. liqpay.ua не відповідає (збій, блокувальник реклами, мережа)
                                                   → опції «Картка» немає;
       3. перед оформленням liqpay.ua знову перевіряється; не відповідає
                                                   → перемикаємо на накладений
                                                     платіж (без нього — на
                                                     реквізити), замовлення ще
                                                     не створене;
       4. бекенд не зміг сформувати платіж          → замовлення вже є, воркер
                                                     переводить його на реквізити;
       5. покупець повернувся без оплати / відмова  → те саме, і менеджер
                                                     отримує оповіщення;
       6. сторінка LiqPay не відкрилась і покупець
          натиснув «Назад»                           → як у п. 5. */

  var LIQPAY_PROBE_URL = 'https://www.liqpay.ua/favicon.ico';
  var LIQPAY_ACTION_RE = /^https:\/\/www\.liqpay\.ua\//;
  var PENDING_KEY = 'np-checkout:liqpay-pending';

  /* Чи досяжний liqpay.ua з браузера покупця. Запит no-cors: вміст нам не
     потрібен, важливо лише, чи мережа взагалі дістає до сервера. */
  function probeLiqpay(timeout) {
    if (!window.fetch) return Promise.resolve(false);

    var controller = window.AbortController ? new AbortController() : null;
    var timer = null;

    var timeoutPromise = new Promise(function (resolve) {
      timer = setTimeout(function () {
        if (controller) controller.abort();
        resolve(false);
      }, timeout);
    });

    var request = fetch(LIQPAY_PROBE_URL + '?t=' + Date.now(), {
      mode: 'no-cors',
      cache: 'no-store',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    }).then(
      function () {
        return true;
      },
      function () {
        return false;
      }
    );

    return Promise.race([request, timeoutPromise]).then(function (ok) {
      clearTimeout(timer);
      return ok;
    });
  }

  function showPaymentNotice(message) {
    paymentNotice.textContent = message || '';
    paymentNotice.hidden = !message;
  }

  function checkedPayment() {
    return form.querySelector('[name="payment"]:checked');
  }

  function enableLiqpay() {
    if (!liqpayOption || !liqpayInput) return;
    state.liqpayAvailable = true;
    liqpayOption.hidden = false;
    liqpayInput.disabled = false;
    // Реквізити — лише запасний шлях, поки картка працює їх не видно.
    if (bankOption && bankInput) {
      bankInput.disabled = true;
      bankOption.hidden = true;
    }
    /* Картка — спосіб за замовчуванням. Але якщо покупець за ці секунди
       вже сам клацнув накладений платіж, його вибір не перебиваємо. */
    if (!state.paymentTouched || !checkedPayment()) liqpayInput.checked = true;
    if (!state.busy) submitLabel.textContent = idleLabel();
  }

  function disableLiqpay(message) {
    state.liqpayAvailable = false;
    var lostChoice = liqpayInput ? liqpayInput.checked : false;
    if (liqpayOption && liqpayInput) {
      liqpayInput.checked = false;
      liqpayInput.disabled = true;
      liqpayOption.hidden = true;
    }
    if (bankOption && bankInput) {
      bankOption.hidden = false;
      bankInput.disabled = false;
    }
    /* Вибір мусить кудись перейти. Накладений платіж працює завжди, тож
       він і стає запасним; реквізити лишаються видимі поруч, але самі
       себе не обирають. Без накладеного — як раніше, реквізити. */
    if (lostChoice || !checkedPayment()) {
      if (codInput) codInput.checked = true;
      else if (bankInput) bankInput.checked = true;
    }
    if (message) showPaymentNotice(message);
    if (!state.busy) submitLabel.textContent = idleLabel();
  }

  form.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'payment') {
      state.paymentTouched = true;
      showError('payment', '');
      if (!state.busy) submitLabel.textContent = idleLabel();
    }
  });

  function sessionSet(value) {
    try {
      if (value) sessionStorage.setItem(PENDING_KEY, JSON.stringify(value));
      else sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {
      /* приватний режим — без цієї страховки */
    }
  }

  function sessionGet() {
    try {
      var raw = sessionStorage.getItem(PENDING_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  /* Відправляє покупця на сторінку LiqPay. Підпис зробив воркер,
     браузер лише пересилає data + signature. */
  function redirectToLiqpay(liqpay, orderName) {
    sessionSet({ orderName: orderName, lp: liqpay.orderId || '', at: Date.now() });

    var redirect = document.createElement('form');
    redirect.method = 'POST';
    redirect.action = liqpay.action;
    redirect.acceptCharset = 'utf-8';
    redirect.hidden = true;

    [
      ['data', liqpay.data],
      ['signature', liqpay.signature]
    ].forEach(function (pair) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = pair[0];
      input.value = pair[1];
      redirect.appendChild(input);
    });

    document.body.appendChild(redirect);

    /* Якщо за 20 с сторінка так і не пішла на LiqPay — щось заважає.
       Показуємо результат так само, як після повернення. */
    var left = false;
    window.addEventListener(
      'pagehide',
      function () {
        left = true;
      },
      { once: true }
    );
    setTimeout(function () {
      if (!left && document.visibilityState === 'visible') {
        sessionSet(null);
        showLiqpayReturn({ orderName: orderName, lp: liqpay.orderId || '' });
      }
    }, 20000);

    redirect.submit();
  }

  function fetchStatus(lp) {
    return fetch(api('/api/liqpay/status?id=' + encodeURIComponent(lp)), { cache: 'no-store' })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        return (data && data.status) || 'unknown';
      })
      .catch(function () {
        return 'unknown';
      });
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  /* Покупець повернувся з LiqPay (або сторінка LiqPay не відкрилась).
     Самому факту повернення не віримо — питаємо воркер. Колбек LiqPay
     може запізнитись на кілька секунд, тому «в обробці» перепитуємо. */
  function showLiqpayReturn(info) {
    renderDone({
      title: 'Перевіряємо оплату…',
      orderName: info.orderName,
      text: 'Це займе кілька секунд.',
      bank: false
    });

    fetch('/cart/clear.js', { method: 'POST' }).catch(function () {});

    if (!info.lp || !API) {
      finishLiqpayReturn(info, 'unknown');
      return;
    }

    var delays = [0, 2500, 4000, 6000];
    var last = 'unknown';

    (function attempt(index) {
      if (index >= delays.length) {
        finishLiqpayReturn(info, last);
        return;
      }
      wait(delays[index])
        .then(function () {
          return fetchStatus(info.lp);
        })
        .then(function (status) {
          last = status;
          if (status === 'paid' || status === 'failed') finishLiqpayReturn(info, status);
          else attempt(index + 1);
        });
    })(0);
  }

  function finishLiqpayReturn(info, status) {
    if (status === 'paid') {
      renderDone({
        title: 'Оплату отримано',
        orderName: info.orderName,
        text: 'Дякуємо! Замовлення оплачене, відправимо його найближчим часом.',
        bank: false
      });
      return;
    }

    if (status === 'failed') {
      renderDone({
        title: 'Замовлення прийнято',
        orderName: info.orderName,
        notice: 'Оплата карткою не пройшла. Нічого страшного — замовлення збережене, його можна оплатити переказом.',
        text: bankText(),
        bank: true,
        retryId: info.lp
      });
      return;
    }

    // pending / unknown: не показуємо реквізити, щоб не було подвійної оплати.
    renderDone({
      title: 'Замовлення прийнято',
      orderName: info.orderName,
      notice:
        status === 'pending'
          ? 'Оплата ще обробляється банком.'
          : 'Не вдалося перевірити статус оплати.',
      text:
        'Якщо гроші списались — усе гаразд, ми отримаємо підтвердження й відправимо замовлення. ' +
        'Якщо оплата не пройде, надішлемо реквізити для переказу.',
      bank: false
    });
  }

  /* «Спробувати оплатити карткою ще раз»: воркер формує новий платіж для
     того самого замовлення (нове замовлення не створюється). Реквізити
     при цьому лишаються на екрані — не вийде карткою, можна переказом. */
  if (retryButton) {
    retryButton.addEventListener('click', function () {
      if (!state.retry || retryButton.disabled) return;
      var retry = state.retry;
      retryButton.disabled = true;
      retryButton.textContent = 'Готуємо оплату…';

      probeLiqpay(4000)
        .then(function (ok) {
          if (!ok) throw new Error('liqpay');
          return fetch(api('/api/liqpay/retry'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: retry.lp,
              returnUrl: window.location.origin + window.location.pathname
            })
          }).then(function (response) {
            return response.json();
          });
        })
        .then(function (data) {
          var liqpay = data && data.liqpay;
          if (
            data &&
            data.ok &&
            liqpay &&
            liqpay.data &&
            liqpay.signature &&
            LIQPAY_ACTION_RE.test(String(liqpay.action || ''))
          ) {
            retryButton.textContent = 'Переходимо на LiqPay…';
            redirectToLiqpay(liqpay, retry.orderName);
            return;
          }
          if (data && data.paid) {
            finishLiqpayReturn(retry, 'paid');
            return;
          }
          throw new Error((data && data.error) || 'retry');
        })
        .catch(function () {
          retryButton.hidden = true;
          doneNotice.textContent =
            'Онлайн-оплата карткою зараз недоступна — оплатіть, будь ласка, переказом за реквізитами.';
          doneNotice.hidden = false;
        });
    });
  }

  /* Звідки ми тут: повернулись з LiqPay за result_url, або натиснули
     «Назад» на сторінці, яка не відкрилась. */
  function detectLiqpayReturn(fromHistory) {
    var params = new URLSearchParams(window.location.search);
    if (params.get('np_payment') === 'liqpay' && params.get('np_order')) {
      sessionSet(null);
      return { orderName: params.get('np_order'), lp: params.get('np_lp') || '' };
    }

    if (!fromHistory) return null;

    var saved = sessionGet();
    if (saved && saved.orderName && Date.now() - Number(saved.at || 0) < 2 * 60 * 60 * 1000) {
      sessionSet(null);
      return saved;
    }
    return null;
  }

  function cameBackFromHistory() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      return Boolean(entry && entry.type === 'back_forward');
    } catch (error) {
      return false;
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    var info = detectLiqpayReturn(true);
    if (info) {
      setBusy(false);
      showLiqpayReturn(info);
    }
  });

  /* ── Meta Pixel: Purchase ─────────────────────────────────────────────

     Спрацьовує один раз, щойно замовлення створене в Shopify (і для
     картки, і для реквізитів). Сума — total з відповіді воркера, тобто
     з самого замовлення Shopify, разом із доставкою. eventID = номер
     замовлення, а localStorage не дає продублювати подію при
     поверненні з LiqPay чи оновленні сторінки. */
  var META_SENT_KEY = 'np-checkout:meta-purchase';

  function trackMetaPurchase(data, cart) {
    if (typeof window.ukrMetaTrack !== 'function' || !data || !data.orderName) return;

    var sent = [];
    try {
      sent = JSON.parse(localStorage.getItem(META_SENT_KEY) || '[]');
    } catch (error) {
      sent = [];
    }
    if (sent.indexOf(data.orderName) !== -1) return;

    var items = (cart && cart.items) || [];
    var value = Number(data.total);
    if (!(value > 0)) value = ((cart ? cart.total_price : 0) + shippingCents()) / 100;

    window.ukrMetaTrack(
      'Purchase',
      {
        value: Math.round(value * 100) / 100,
        currency: (cart && cart.currency) || 'UAH',
        content_type: 'product',
        content_ids: items.map(function (item) {
          return String(item.product_id);
        }),
        contents: items.map(function (item) {
          return {
            id: String(item.product_id),
            quantity: item.quantity,
            item_price: Number(item.final_price || item.price || 0) / 100
          };
        }),
        num_items: items.reduce(function (sum, item) {
          return sum + item.quantity;
        }, 0),
        order_id: data.orderName
      },
      'purchase-' + data.orderName
    );

    try {
      sent.push(data.orderName);
      localStorage.setItem(META_SENT_KEY, JSON.stringify(sent.slice(-20)));
    } catch (error) {
      /* приватний режим — ок */
    }
  }

  /* ── Відправка ────────────────────────────────────────────────────── */

  function sendOrder(payment) {
    var payload = {
      customer: {
        firstName: form.querySelector('[name="firstName"]').value.trim(),
        lastName: form.querySelector('[name="lastName"]').value.trim(),
        middleName: form.querySelector('[name="middleName"]').value.trim(),
        phone: phoneInput.value.replace(/\D/g, ''),
        email: form.querySelector('[name="email"]').value.trim()
      },
      delivery: {
        type: state.warehouse.category === 'Postomat' ? 'postomat' : 'branch',
        areaName: state.area.name,
        cityName: state.city.name,
        cityRef: state.city.ref,
        warehouseName: state.warehouse.name,
        warehouseRef: state.warehouse.ref
      },
      payment: payment,
      returnUrl: window.location.origin + window.location.pathname,
      note: form.querySelector('[name="note"]').value.trim(),
      items: state.cart.items.map(function (item) {
        return { variant_id: item.variant_id, quantity: item.quantity };
      }),
      // Якщо покупець писав у живий чат — консультант побачить замовлення у своїй темі.
      chatVisitor: typeof window.ukrChatVisitor === 'function' ? window.ukrChatVisitor() : ''
    };

    setBusy(true, payment === 'liqpay' ? 'Готуємо оплату…' : 'Оформлюємо…');

    fetch(api('/api/order'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { status: response.status, data: data };
        });
      })
      .then(function (result) {
        var data = result.data || {};

        if (data.ok) {
          trackMetaPurchase(data, state.cart);
          return fetch('/cart/clear.js', { method: 'POST' })
            .catch(function () {})
            .then(function () {
              if (payment !== 'liqpay') {
                showDone(data.orderName, { payment: payment });
                return;
              }

              var liqpay = data.liqpay;
              var usable =
                !data.liqpayFailed &&
                liqpay &&
                liqpay.data &&
                liqpay.signature &&
                LIQPAY_ACTION_RE.test(String(liqpay.action || ''));

              if (usable) {
                setBusy(true, 'Переходимо на LiqPay…');
                /* Невелика пауза, щоб запит Meta Pixel встиг піти до переходу. */
                setTimeout(function () {
                  redirectToLiqpay(liqpay, data.orderName);
                }, 400);
                return;
              }

              if (liqpay && liqpay.orderId) {
                /* Форма прийшла зіпсована. Воркер про це не знає — хай
                   статус-запит переведе замовлення на реквізити. */
                showLiqpayReturn({ orderName: data.orderName, lp: liqpay.orderId });
                return;
              }

              showDone(data.orderName, {
                notice:
                  'Онлайн-оплата зараз недоступна, тому замовлення оформлене з оплатою за реквізитами.',
                retryId: data.retryId || ''
              });
            });
        }

        setBusy(false);

        // Замовлення не створене: LiqPay вимкнули на бекенді.
        if (data.code === 'liqpay_unavailable') {
          disableLiqpay(
            codOption
              ? 'Онлайн-оплата тимчасово недоступна — обрали накладений платіж.'
              : 'Онлайн-оплата тимчасово недоступна — обрали оплату за реквізитами.'
          );
          showFormError(retryHint());
          return;
        }

        if (data.errors) {
          Object.keys(data.errors).forEach(function (key) {
            showError(key, data.errors[key]);
          });
          showFormError('Перевірте виділені поля.');
          return;
        }

        showFormError(
          data.error || 'Не вдалося оформити замовлення. Спробуйте ще раз або зателефонуйте нам.'
        );
      })
      .catch(function () {
        setBusy(false);
        showFormError('Немає зв’язку із сервером. Перевірте інтернет і спробуйте ще раз.');
      });
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (state.busy) return;
    if (!API) {
      showFormError('Бекенд чекауту не налаштований.');
      return;
    }
    if (!validate()) return;

    // Ще не з'ясували, картка чи реквізити, — чекаємо (максимум 9 с).
    if (!state.paymentSettled && paymentReady) {
      setBusy(true, 'Перевіряємо оплату…');
      paymentReady.then(function () {
        setBusy(false);
        submitButton.click();
      });
      return;
    }

    var payment = selectedPayment();

    if (payment !== 'liqpay') {
      sendOrder(payment);
      return;
    }

    /* Ще раз перевіряємо LiqPay просто перед оформленням: за час
       заповнення форми він міг упасти. Замовлення ще не створене,
       тож можна спокійно перемкнути на реквізити. */
    setBusy(true, 'Перевіряємо LiqPay…');
    probeLiqpay(4000).then(function (ok) {
      if (ok) {
        sendOrder('liqpay');
        return;
      }
      setBusy(false);
      disableLiqpay(
        codOption
          ? 'LiqPay зараз не відповідає — обрали накладений платіж.'
          : 'LiqPay зараз не відповідає — обрали оплату за реквізитами.'
      );
      showFormError(retryHint());
    });
  });

  /* ── Старт ────────────────────────────────────────────────────────── */

  var returned = detectLiqpayReturn(cameBackFromHistory());
  if (returned) {
    showLiqpayReturn(returned);
    return;
  }

  loadCart();
  loadConfig();
  loadAreas();
})();
